module.exports = __webpack_public_path__ + "static/media/S3N6-1.127b0a9a.svg";